import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import FilterIcon from '@atlaskit/icon/core/filter';
import { IconButton } from '@atlaskit/button/new';

import { usePageCatchupDateFilterStoreActions } from '../stores/PageCatchupDateFilterStore';

const i18n = defineMessages({
	filterSinceLastVisited: {
		id: 'page-catchup.filter.since-last-visited',
		defaultMessage: 'Since last visited',
		description: 'Filter option to show changes since the user last visited the content',
	},
	filterToday: {
		id: 'page-catchup.filter.today',
		defaultMessage: 'Today',
		description: 'Filter option to show changes from the past 24 hours',
	},
	filterPast7Days: {
		id: 'page-catchup.filter.past7days',
		defaultMessage: 'Past 7 Days',
		description: 'Filter option to show changes from the past 7 days',
	},
	filterPast14Days: {
		id: 'page-catchup.filter.past14days',
		defaultMessage: 'Past 14 Days',
		description: 'Filter option to show changes from the past 14 days',
	},
	filterPast30Days: {
		id: 'page-catchup.filter.past30days',
		defaultMessage: 'Past 30 Days',
		description: 'Filter option to show changes from the past 30 days',
	},
	filterAllTime: {
		id: 'page-catchup.filter.alltime',
		defaultMessage: 'All time',
		description: 'Filter option to show all changes',
	},
	filterButtonLabel: {
		id: 'page-catchup.filter.button.label',
		defaultMessage: 'Filter changes',
		description: 'Label for the filter button',
	},
});

export const FilterComponent = () => {
	const filterActions = usePageCatchupDateFilterStoreActions();
	return (
		<DropdownMenu<HTMLButtonElement>
			trigger={({ triggerRef, ...props }) => (
				<IconButton
					{...props}
					testId="page-catchup-filter-button"
					appearance="subtle"
					label={<FormattedMessage {...i18n.filterButtonLabel} />}
					icon={FilterIcon}
					ref={triggerRef}
				/>
			)}
			shouldRenderToParent
		>
			<DropdownItemGroup>
				<DropdownItem onClick={() => filterActions.changeToPeriod('since-last-visit')}>
					<FormattedMessage {...i18n.filterSinceLastVisited} />
				</DropdownItem>
				<DropdownItem onClick={() => filterActions.changeToPeriod('ONE_DAY_AGO')}>
					<FormattedMessage {...i18n.filterToday} />
				</DropdownItem>
				<DropdownItem onClick={() => filterActions.changeToPeriod('ONE_WEEK_AGO')}>
					<FormattedMessage {...i18n.filterPast7Days} />
				</DropdownItem>
				<DropdownItem onClick={() => filterActions.changeToPeriod('TWO_WEEKS_AGO')}>
					<FormattedMessage {...i18n.filterPast14Days} />
				</DropdownItem>
				<DropdownItem onClick={() => filterActions.changeToPeriod('ONE_MONTH_AGO')}>
					<FormattedMessage {...i18n.filterPast30Days} />
				</DropdownItem>
				<DropdownItem onClick={() => filterActions.changeToPeriod('ALL_TIME')}>
					<FormattedMessage {...i18n.filterAllTime} />
				</DropdownItem>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
